(ns guidebook.views.family-profile
  (:require
   [guidebook.common :refer [title-s body-s]]
   [very.re-frame.core :as rf :refer [>evt]]
   [cljss.core :as cljss]
   [css.core
    :refer [get-theme]
    :refer-macros [defstyled]]))

(defstyled profile-template-s :div
  {:color "white"
   :padding-left "54px"
   :background-image "url(/assets/icons/user-2.svg)"
   :background-repeat "no-repeat"
   :background-position "left top"
   :background-size "24px"
   ::cljss/media {[:print]
                  {:page-break-inside "avoid"}}})

(defstyled name-age-s :div
  {::cljss/media {[:print]
                  {:display "flex"
                   :flex-direction "row"
                   :align-items "center"
                   :margin-bottom "1rem"}}})

(defstyled name-s :h3
  {:font-size "32px"
   :margin-bottom "21px"
   ::cljss/media {[:print]
                  {::-webkit-margin-before 0
                   :-webkit-margin-after 0
                   :font-size "28px"
                   :margin-bottom "0"}}})

(defstyled age-s :div
  {:margin-bottom "21px"
   :font-size "20px"
   :font-weight "700"
   ::cljss/media {[:print]
                  {:font-size "16px"
                   :margin-bottom "0"
                   :margin-left "40px"}}})

(defstyled data-s :div
  {:font-weight "300"
   :font-size "25px"
   :margin-bottom "21px"
   :&:last-child {:margin-bottom "0"}
   ::cljss/media {[:print]
                  {:font-size "20px"
                   :margin-bottom "1rem"}}})

(defn profile-template [profile]
  [profile-template-s
   [name-age-s
    (when (:name profile) [name-s (:name profile)])
    (when (:age profile) [age-s (:age profile)])]
   (when (:relationship profile) [data-s (:relationship profile)])
   (when (:phone profile) [data-s (:phone profile)])
   (when (:email profile) [data-s (:email profile)])
   (when (:occupation profile) [data-s (:occupation profile)])
   (when (:retired profile) [data-s (:retired profile)])
   (when (:retirementDate profile) [data-s (:retirementDate profile)])])

(defstyled family-profile-s :div
  {:display "grid"
   :grid-template-columns "1fr 1fr"
   :align-items "flex-start"
   :padding-top "100px"
   :grid-gap "5rem"
   :min-height "100vh"
   :position "relative"
   ::cljss/media {[:print]
                  {:display "flex"
                   :flex-direction "column"
                   :width "calc(100% - 50px)"
                   :margin-left "50px"
                   :padding-top "100px"
                   :background-position "center"}}})

(defstyled family-wrapper-s :div
  {:padding-bottom "6rem"})

(defstyled family-background-s :div
  {:position "absolute"
   ::background-image "url(/assets/trees.png)"
   :background-repeat "no-repeat"
   :background-position "center"
   :background-size "cover"
   :top "0"
   :left "50px"
   :right "0"
   :bottom "0"
   ::cljss/media {[:print]
                  {:top "50px"}}})

(defstyled children-header-s :h3
  {:border-top "1px solid rgba(250,250,250,0.3)"
   :text-align "center"
   :padding "3.75rem 0"
   :margin-top "3.75rem"
   :color "white"
   :font-weight "700"
   :font-size "20px"
   ::cljss/media {[:print]
                  {:font-size "15px"
                   :padding "3rem 0"
                   :margin-top "3rem"}}})

(defstyled profile-header-s :div
  {:background "black"
   :padding "82px 100px"
   :position "relative"
   :left "-50px"})

(defstyled profile-description-s :p
  {:color "white"
   :font-size "25px"
   :line-height "36px"
   :font-weight "300"
   :max-width "580px"
   :-webkit-margin-before 0
   :-webkit-margin-after 0})

(defstyled family-s :div
  {:padding-right "100px"
   ::cljss/media {[:print]
                  {:width "100%"
                   :padding "50px 100px"}}})

(defstyled family-grid-s :div
  {:display "grid"
   :grid-template-columns "1fr 1fr"
   :grid-row-gap "60px"
   :grid-column-gap "30px"
   :width "100%"})

(defn main []
  (let [family-profile (rf/subscribe [:guidebook/family-profile])]
    (fn []
      (let [{:keys [parents children]} @family-profile]
        [family-wrapper-s
         [family-background-s]
         [family-profile-s
          [profile-header-s
           [title-s {:color "white"
                     :margin "0"} "Family Profile"]]
          [family-s
           (into [family-grid-s] (map profile-template parents))
           (when (pos? (count children))
                 [:div
                  [children-header-s "CHILDREN"]
                  (into [family-grid-s] (map profile-template children))])]]]))))
